// extracted by mini-css-extract-plugin
export var keyboardOuter = "keyboard-module--keyboard-outer--2JbyA";
export var keyboardInner = "keyboard-module--keyboard-inner--3jUeL";
export var keyboardPlus = "keyboard-module--keyboard-plus--1AAXq";